export const LOGIN_ROUTE = "/login";
export const LOGOUT_ROUTE = "/logout";
export const LOGOUT_SUCCESS_ROUTE = "/logout-success";
export const CONFIRMATION_ROUTE = "/confirmation";
export const CONFIRMATION_ENTERPRISE_ROUTE = "/confirmation-enterprise";
export const RESET_PASSWORD_ROUTE = "/reset-password";

export const ACCESS_CREDENTIALS_ROUTE = "access-credentials";
export const BUCKETS_ROUTE = "buckets";
export const DASHBOARD_ROUTE = "dashboard";
export const USERS_ROUTE = "users";
export const GROUPS_ROUTE = "groups";
export const POLICIES_ROUTE = "policies";
export const ROLES_ROUTE = "roles";
export const SHARD_CLUSTERS_ROUTE = "shard-clusters";
export const STORAGE_PROVIDERS_ROUTE = "storage-providers";
export const SHARD_REPOSITORIES_ROUTE = "shard-repositories";
export const ENTERPRISE_ACCOUNT_SETUP_ROUTE = "enterprise-account-setup";
export const SETTINGS_ROUTE = "settings";
export const ARCHIVE_ROUTE = "archives";

export const API_ROUTES = {
  shardRepository: "storage/node",
  shardCluster: "storage/pool",
};

export function getAbsoluteRoute(route: string) {
  if (!route.startsWith("/")) {
    return `/${route}`;
  }

  return route;
}

export enum DefaultRouteParam {
  IdOrAction = "idOrAction",
}

export enum DefaultRouteAction {
  New = "new",
}

export enum MFARouteAction {
  Verification = "verification",
}

export enum ShardClusterRouteParam {
  ShardRepositoryIdOrAction = "shardRepositoryIdOrAction",
}

export enum AccessCredentialsRouteAction {
  AddCredentials = "add-credentials",
}

export enum StorageProviderRouteParam {
  Template = "template",
}
